// extracted by mini-css-extract-plugin
module.exports = {"percentInput":"src-components-PercentTextInput-styles___percentInput"};